import React, {useContext} from 'react';
import './checkout.css';
import { PRODUCTS } from "../../products";
import {ShopContext} from '../../componets/context/shopContext';
import { findProductById } from '../../componets/context/shopContext';

export const Checkout = () => {

    const { cartItems,getTotalAmount } = useContext(ShopContext);
    const totalAmount = getTotalAmount();

    return(
        <div>
            <div className="invoice">
                <h3>Invoice</h3>
            </div>
            <table className="cartItemsTable">
                <thead>
                    <tr>
                    <th>Id</th>
                    <th>Name</th>
                    <th>Price</th>
                    <th>Quantity</th>
                    <th>Total Price</th>
                    </tr>
                </thead>
                <tbody>
                {Object.keys(cartItems).map((productId) => {
                        const product = findProductById(Number(productId), PRODUCTS);
                        const quantity = cartItems[productId];
                        if (product && quantity > 0) {
                            return (
                                <tr key={product.id}>
                                    <td>{product.id}</td>
                                    <td>{product.productName}</td>
                                    <td>₹{product.price}</td>
                                    <td>{quantity}</td>
                                    <td>₹{product.price * quantity}</td>
                        </tr>
                        );
                    }
                        return null;
                    })}
                </tbody>
            </table>
            <div> 
                <h1> Subtotal: ₹ {totalAmount}</h1>
            </div>
            <div className='whatsapp'>
                <h3> Please send a screenshot of this receipt<br/>to Pooja Mohire to confirm your order.</h3>
                <h3>Whatsapp No. <a href="https://wa.me/918668447848">+91 8668447848</a>
                </h3>               
                <h3>Thank You for shopping!</h3>
            </div>
            <div className='TandC'>
                <h3>Important:</h3>
                <h4>*Actual product may vary from the photo.<br></br>
                *Shipping charges will be extra, if applicable.</h4>
            </div>
        </div>
    )
}

export default Checkout;